import React, { useState, useEffect } from 'react';
import { Link } from "react-router-dom";
import { useGlobal } from 'reactn';
import { useTranslation } from 'react-i18next';
import { fmtPrice, fmtDatetime, roundMinutes } from 'stores/utils';
import useLocalStorage from "stores/useLocalStorage.js";
import { useAuth } from 'stores/auth';
import { useApi } from 'stores/api';
import Stepper from 'components/Stepper';

const BWConfirmation = (props) => {
    const api = useApi();
    const [LSIsGuestBooking] = useLocalStorage('ls_igb');
    const [masterData] = useGlobal('masterData');
    const [searchParams] = useGlobal('searchParams');
    const [showGuestLogin] = useGlobal('showGuestLogin');
    const [orderData] = useGlobal('orderData');
    const [orderId] = useGlobal('orderId');
    const [orderDataCopy, setOrderDataCopy] = useState(null);
    const [orderIdCopy, setOrderIdCopy] = useState(`${orderId}`);

    const getPrice = () => {
        if (masterData.organization.FreeOfCharge) return null;
        return <>{t("forPrice")} <span>{orderDataCopy.Currency_Name} {fmtPrice(orderDataCopy.TotalPrice)}</span></>;
    }

    useEffect(() => {
        if (orderData) {
            setOrderDataCopy({ ...orderData });
            setTimeout(() => {
                api.clearOrder();
            }, 1000);
        }
        if (orderId) {
            setOrderIdCopy(`${orderId}`);
        }
    }, [orderId, orderData]);

    const { t } = useTranslation(['wizard-confirmation']);

    if (!orderDataCopy) return <div>Loading...</div>;

    return (
        <>
            <Stepper activeStep="confirmation" />
            {orderIdCopy && orderDataCopy && <section className="wizard-container booking-view">
                <div className="wrapper">
                    <div className="row wizard-content">
                        <div className="column-12">
                            <h3 className="mali-blue margin-bottom">{t("confirmation")}</h3>
                            <div className="success-container">
                                <div className="row">
                                    <div className="success-content column-6 offset-3">
                                        <h4>{t("bookingDetailsSent")}</h4>
                                        {/* {message && <h4>{message}</h4>} */}
                                        <div className="successBtns-container">
                                            {!LSIsGuestBooking && <div className="successBtns-container-left">
                                                <a className="pdf" href={`/api/Lessee/Order/${orderIdCopy}/OrderReport`} target="_blank">{t("performPrint")} <i className="fa fa-print" aria-hidden="true"></i></a>
                                            </div>}
                                            <div className="successBtns-container-right">
                                                <Link className="home" to="/">{t("goHome")} <i className="fa fa-check" aria-hidden="true"></i></Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>}
        </>
    );
}

export default BWConfirmation;